export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10878.4ea8b776.jpg";